import { OreStack } from '@edenredespana/oreneta'
import { FormProvider, UseFormReturn } from 'react-hook-form'

import {
  ContractNewProductsStep3Actions,
  ContractNewProductsStep3Documents,
  ContractNewProductsStep3Resume,
} from '@/Contract/ui/atoms'
import { useContractNewProducts } from '@/Contract/ui/context'
import { Step2Form } from '@/Contract/ui/hooks'
import { ProtectedWrapper } from '@/Shared/ui/navigation'

export const ContractNewProductsStep3 = (): JSX.Element => {
  const { getCurrentStepForm } = useContractNewProducts()

  const form = getCurrentStepForm(2) as UseFormReturn<Step2Form>

  return (
    <ProtectedWrapper>
      <FormProvider {...form}>
        <form>
          <OreStack placeContent="stretch" space="large">
            <ContractNewProductsStep3Resume />
            <ContractNewProductsStep3Documents />

            <ContractNewProductsStep3Actions />
          </OreStack>
        </form>
      </FormProvider>
    </ProtectedWrapper>
  )
}
